import { createApp } from 'vue'
import App from '../App.vue'

let app = null

function mountApp() {
  const appElement = document.getElementById('app')
  if (appElement && !app) {
    app = createApp(App)
    app.mount('#app')
  }
}

// Mount on initial load
document.addEventListener('DOMContentLoaded', mountApp)

// Re-mount on Turbo navigation
document.addEventListener('turbo:load', () => {
  app = null
  mountApp()
})

// Cleanup on before render
document.addEventListener('turbo:before-render', () => {
  if (app) {
    app.unmount()
    app = null
  }
})
